import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { Guid } from 'src/app/core/common';

@Component({
  selector: 'app-manage-agent',
  templateUrl: './manage-agent.component.html',
  styleUrls: ['./manage-agent.component.scss']
})
export class ManageAgentComponent implements OnInit {
  constructor(private userService: UserService, private spinner: SpinnerService) { }
  Guid = Guid;

  users: any[];
  total: number;
  keyword: string;
  limit = 30;

  async ngOnInit() {
    await this.load();
  }

  newuser() {
    this.users.splice(0, 0, { Agent: {} });
  }

  async load(page: { from: number, limit: number } = { from: 0, limit: this.limit }) {
    this.spinner.show('search');
    const result = await this.userService.adminGetList({
      Keyword: this.keyword,
      Roles: ['Agent'],
    }, page.from, page.limit);
    this.users = result.users;
    this.total = result.total;
    this.spinner.hide('search');
  }

  setKey(item: any, key: string, event: Event, field: string) {
    const set = (<HTMLInputElement>event.target).checked;
    if (!item[field]) { item[field] = []; }
    const array = item[field];
    const i = array.indexOf(key);
    if (i >= 0 && !set) { array.splice(i, 1); }
    if (i < 0 && set) { array.push(key); }
  }
  hasKey(array: string[], key: string) {
    return array && array.indexOf(key) >= 0;
  }

  addTag(term) { return term; }

  async save(user: any) {
    this.spinner.show('action-' + user.Id);
    delete user.AccessRights;
    delete user.Roles;
    await this.userService.adminSave(user);
    this.spinner.hide('action-' + user.Id);
  }
}
